import React from 'react';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { ContainerProps, Flex, Skeleton } from '@chakra-ui/react';

export const PlaylistHeaderLoader = (props: ContainerProps) => (
  <ContentContainer
    type={ContentContainerType.LIST}
    pt={4}
    flex="initial"
    {...props}
  >
    <Flex>
      <Skeleton height="128px" minWidth="128px" />
      <Flex direction="column" pl={4} pt={2} w="full">
        <Skeleton
          height="38px"
          width="100%"
          maxWidth="500px"
          margin="6px 0px 8px"
        />
        <Skeleton height="14px" width="140px" mb={2} />
        <Skeleton height="14px" width="140px" />
      </Flex>
    </Flex>
  </ContentContainer>
);
